// extracted by mini-css-extract-plugin
module.exports = {"link":"SkipToContent_link__kU7zm"};